module.exports = __webpack_public_path__ + "static/fonts/element-icons.535877f.woff";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 564
// module chunks = 8